import React from "react";
import PropTypes from "prop-types";
// import { themr } from "react-css-themr";
// import classnames from "classnames";
import { parse, addDays } from "date-fns";
import Decimal from "decimal.js-light";
import CardLimitBadge from "../CardLimitBadge";
// import Badge from "components/visual/Badge";
// import CardSmsControl from "../controls/CardSmsControl";

// import cardtype from "./cardtype";
// import styles from "./Limit.m.scss";

function Limit(props) {
  const { limit } = props;

  const {
    limitId,
    limitDays,
    limitAmount,
    limitStartDate,
    limitDaysThreshold,
    limitAmountThreshold,
    limitType,
    limitPeriodType,
    isIndividual,
  } = limit;

  const amountSpentStr =
    typeof limitAmount === "number" ? new Decimal(limitAmount).toString() : "-";
  const amountLeftStr =
    typeof limitAmount === "number" && typeof limitAmountThreshold === "number"
      ? new Decimal(limitAmountThreshold).minus(limitAmount).toString()
      : "-";
  const amountThresholdStr =
    typeof limitAmountThreshold === "number"
      ? new Decimal(limitAmountThreshold).toString()
      : "-";

  return (
    <CardLimitBadge
      limitId={limitId}
      amountSpent={amountSpentStr}
      amountLeft={amountLeftStr}
      amountThreshold={amountThresholdStr}
      limitType={limitType}
      limitPeriodType={limitPeriodType}
      isIndividual={isIndividual}
      dateFrom={limitStartDate ? parse(limitStartDate) : null}
      dateTo={
        limitStartDate && limitDaysThreshold
          ? addDays(parse(limitStartDate), limitDaysThreshold)
          : null
      }
      totalDays={limitDaysThreshold}
      daysPassed={limitDays}
      limitPeriodActivated={!!limitStartDate}
    />
  );
}

Limit.displayName = "Limit";

Limit.propTypes = {
  theme: PropTypes.object,
  limit: PropTypes.object,
};

Limit.defaultProps = {};

export default Limit;



// WEBPACK FOOTER //
// ./src/components/emission/cards/limits/Limit/Limit.js